import {
  Stack,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function BrandConfigReportSkeleton() {
  return (
    <Paper sx={{ p: 3 }}>
      {/* Title Section */}
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Skeleton width={280} height={32} />
        <Skeleton width={520} height={20} />
      </Stack>

      {/* Search + Filters + Donut Chart */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ mb: 2 }}
      >
        {/* Left: Search + Filters */}
        <Stack spacing={2} sx={{ flex: 1 }}>
          {/* Search Bar */}
          <Skeleton variant="rounded" width={280} height={40} />

          {/* Filter Buttons Row */}
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Skeleton variant="rounded" width={180} height={36} />
            <Skeleton variant="rounded" width={120} height={36} />
            <Skeleton variant="rounded" width={100} height={36} />
            <Skeleton variant="rounded" width={160} height={36} />
            <Skeleton variant="rounded" width={110} height={36} />
            <Skeleton variant="rounded" width={120} height={36} />
            <Skeleton variant="rounded" width={140} height={36} />
          </Stack>
        </Stack>

        {/* Right: Donut Chart + Legend */}
        <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 3 }}>
          {/* Donut Chart */}
          <Skeleton variant="circular" width={100} height={100} />

          {/* Legend */}
          <Stack spacing={1}>
            {/* Advisor */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={80} height={16} />
              <Skeleton width={50} height={16} />
            </Stack>
            {/* Fetcher */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={80} height={16} />
              <Skeleton width={50} height={16} />
            </Stack>
            {/* Properties */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={80} height={16} />
              <Skeleton width={50} height={16} />
            </Stack>
            {/* Unifier */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={80} height={16} />
              <Skeleton width={50} height={16} />
            </Stack>
            {/* Validations */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={80} height={16} />
              <Skeleton width={50} height={16} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      {/* Table */}
      <TableContainer sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Skeleton width={60} height={16} /></TableCell>
              <TableCell><Skeleton width={100} height={16} /></TableCell>
              <TableCell><Skeleton width={70} height={16} /></TableCell>
              <TableCell><Skeleton width={130} height={16} /></TableCell>
              <TableCell><Skeleton width={70} height={16} /></TableCell>
              <TableCell><Skeleton width={60} height={16} /></TableCell>
              <TableCell><Skeleton width={80} height={16} /></TableCell>
              <TableCell><Skeleton width={60} height={16} /></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.from({ length: 5 }).map((_, i) => (
              <TableRow key={i}>
                {/* Brand Name */}
                <TableCell><Skeleton width={140} height={20} /></TableCell>
                
                {/* Affiliate System */}
                <TableCell><Skeleton width={80} height={20} /></TableCell>
                
                {/* Website - Purple chip */}
                <TableCell>
                  <Skeleton variant="rounded" width={160} height={26} />
                </TableCell>
                
                {/* Integration Status - Alert badge */}
                <TableCell>
                  <Skeleton variant="rounded" width={90} height={28} />
                </TableCell>
                
                {/* Stuck At */}
                <TableCell><Skeleton width={80} height={20} /></TableCell>
                
                {/* Reason */}
                <TableCell><Skeleton width={140} height={20} /></TableCell>
                
                {/* Last Run */}
                <TableCell><Skeleton width={120} height={20} /></TableCell>
                
                {/* Action */}
                <TableCell><Skeleton width={100} height={20} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination Footer */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 2 }}
      >
        {/* Left: Row count */}
        <Skeleton width={80} height={20} />

        {/* Center: Pagination buttons */}
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" width={32} height={32} />
          <Skeleton variant="rounded" width={32} height={32} />
          <Skeleton variant="rounded" width={32} height={32} />
          <Skeleton variant="rounded" width={32} height={32} />
        </Stack>

        {/* Right: Rows per page */}
        <Stack direction="row" spacing={1} alignItems="center">
          <Skeleton width={100} height={20} />
          <Skeleton variant="rounded" width={60} height={32} />
        </Stack>
      </Stack>
    </Paper>
  );
}